import Marquee from "react-fast-marquee";

const ITEMS = [
  "AdStellar Media",
  "IndiGo",
  "BMW",
  "AJIO",
  "Aditya Birla",
  "Trusted by 500+ Clients",
  "Performance First",
];

export const MarqueeBand = () => (
  <section data-testid="marquee-band" className="py-16 md:py-24 border-b border-white/10 overflow-hidden" aria-label="Trusted by leading brands">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={item} className="flex items-center shrink-0">
          <span
            className={`font-display text-5xl md:text-7xl px-8 md:px-12 whitespace-nowrap ${
              i % 2 === 0 ? "italic text-[#F8F8F8]" : "text-[#3a3a40]"
            }`}
          >
            {item}
          </span>
          <span className="text-[#8B5CF6] text-2xl" aria-hidden="true">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
